import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../Header';
import Sidebar from '../Sidebar';
import watermarkImage from '../assets/coverzone-watermark.png';

const API_URL = process.env.REACT_APP_API_URL;

const Medical = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const [user, setUser] = useState<{ id: number; email: string; first_name?: string; surname?: string; username?: string; organization?: string } | null>(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }
        const response = await axios.get(`${API_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        console.error('Error fetching user:', error);
        localStorage.removeItem('token');
        navigate('/login');
      }
    };
    fetchUser();
  }, [navigate]);

  // Placeholder: Fetch client data if needed
  useEffect(() => {
    
    console.log(`Client ID: ${clientId}`);
  }, [clientId]);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.error('Failed to load watermark image:', e);
  };

  const handleImageLoad = (type: string) => {
    console.log(`${type} image loaded successfully`);
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-100 flex relative">
      {/* Watermark */}
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-0">
        <img
          src={watermarkImage}
          alt="Watermark"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-100 h-100 opacity-5 z-0 select-none"
          onError={handleImageError}
          onLoad={() => handleImageLoad('Watermark')}
        />
      </div>

      {/* Sidebar */}
      <Sidebar isVisible={isSidebarVisible} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarVisible ? 'ml-64' : 'ml-0'}`}>
        {/* Header */}
        <Header
          title={`Medical Details - `}
          user={user}
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />

        {/* Content */}
        <div className="flex-1 p-6">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-4xl mx-auto">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Medical Details for Client ID: {clientId}
            </h2>
            <p className="text-gray-600">
              This is a placeholder page for the Medical details of client {clientId}.
              {/* Add client-specific content here */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Medical;